export const TRIP_PLANNER_SIDE_NAV_ID = 'trip-planner-side-nav'

export const MIN_CHAT_SEARCH_QUERY_LENGTH = 2

/** The nav's inline inset for headings, chat rows and the footer. */
export const TRIP_PLANNER_NAVIGATION_GUTTER = 20

/** Insets list rows so their hover fill sits inside the nav while their icons line up past the gutter, as in Figma. */
export const TRIP_PLANNER_NAVIGATION_ROW_INSET = 12

/** The site nav row's height on every breakpoint, so the TripPlanner top bars line up with the homepage's. */
export const TRIP_PLANNER_HEADER_HEIGHT = 64
